import classNames from 'classnames/bind'
import React, { ReactNode } from 'react'
import { useAppSelector } from '@/redux/hooks'
import { isEmpty, isString } from 'lodash-es'
import Link from 'next/link'

// Libs
import { useServiceList } from './utils/useServiceList'

// Constants
import { REGION } from '@/constants/region'

// Styles
import styles from './style.module.scss'
const cx = classNames.bind(styles)

interface IServiceItem {
  children: ReactNode
  url?: string
  onClick?: () => void
  allowRegions?: Set<string>
}

export interface IServiceCategory {
  title: string
  items: IServiceItem[]
  isMobileFullWidth?: boolean
}

const ServiceItem = ({ title, items, isMobileFullWidth }: IServiceCategory) => {
  const commonData = useAppSelector((state) => state.common)
  const dittoCountryCode: string =
    !isEmpty(commonData) && !isEmpty(commonData?.locationData) && !isEmpty(commonData?.locationData?._dittoCountryCode)
      ? commonData?.locationData?._dittoCountryCode || REGION.TW
      : REGION.TW

  return (
    <div className={cx('service-item', { 'full-width': isMobileFullWidth })}>
      <div className={cx('service-item__title')}>{title}</div>
      <div className={cx('service-item__links')}>
        {items.map((item) => {
          if (item.allowRegions && !item.allowRegions.has(dittoCountryCode)) return null
          if (isString(item.children)) {
            return (
              <Link
                href={item.url ?? ''}
                onClick={item.onClick}
                className={cx('service-item__links__item')}
                key={String(item.children)}
                target='_blank'
              >
                {item.children}
              </Link>
            )
          }

          return item.children
        })}
      </div>
    </div>
  )
}

const ServiceList = () => {
  const services = useServiceList()
  return (
    <div className={cx('service-list')}>
      {services.map((service) => (
        <ServiceItem key={service.title} {...service} />
      ))}
    </div>
  )
}

export default ServiceList
